import AsyncStorage from '@react-native-async-storage/async-storage'
import { RelayablyWorkspaceDocument, UsageType } from '@monorepo/relayably/workspaces'

const PENDING_ONBOARDING_CHECKOUT_KEY = 'relayably.workspace.pending-checkout'

export type PendingComplianceUpload = {
  base64: string
  documentType: string
  fileName: string
  label?: string
  mimeType?: string
  requirementName: string
}

export type PendingOnboardingCheckout = {
  checkoutSessionId?: string
  createdAt: string
  pendingComplianceUploads?: PendingComplianceUpload[]
  planId: UsageType
  workspace: RelayablyWorkspaceDocument
}

const browserStorage = () => {
  if (typeof window !== 'undefined' && window.localStorage) {
    return window.localStorage
  }

  return null
}

export const onboardingCheckoutStorage = {
  async clear() {
    const storage = browserStorage()

    if (storage) {
      storage.removeItem(PENDING_ONBOARDING_CHECKOUT_KEY)
      return
    }

    await AsyncStorage.removeItem(PENDING_ONBOARDING_CHECKOUT_KEY)
  },

  async get() {
    const storage = browserStorage()
    const rawValue = storage ? storage.getItem(PENDING_ONBOARDING_CHECKOUT_KEY) : await AsyncStorage.getItem(PENDING_ONBOARDING_CHECKOUT_KEY)

    if (!rawValue) {
      return null
    }

    return JSON.parse(rawValue) as PendingOnboardingCheckout
  },

  async set(value: PendingOnboardingCheckout) {
    const serialised = JSON.stringify(value)
    const storage = browserStorage()

    if (storage) {
      storage.setItem(PENDING_ONBOARDING_CHECKOUT_KEY, serialised)
      return
    }

    await AsyncStorage.setItem(PENDING_ONBOARDING_CHECKOUT_KEY, serialised)
  },
}
